"use client";

import Image from "next/image";
import styles from "./styles.module.scss";
import { useEffect, useRef } from "react";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export default function ProgramsSearch({ programs, setFilteredPrograms , previousPrograms, query, setQuery}) {
  const firstRender = useRef(true);

  function searchPrograms(query, programs) {
    query = query.toLowerCase().trim(); // Convert query to lowercase for case-insensitive search
    const queryWithUnderscore = query.replace(/\s+/g, "_");

    return programs?.filter((program) => {
      const { programName, domain,attributes,tools, sponsoredBy, sponseredKey } = program;
      const {BannerSlider}=attributes;
      const {Heading}= BannerSlider || {};
      const {text:heading}=Heading || ''

      // Convert all strings to lowercase for comparison
      const lowercaseProgramName = programName?.toLowerCase();
      const lowercaseHeading = heading?.toLowerCase();
      const lowercaseSponsoredBy = sponsoredBy?.toLowerCase()?.trim() || sponseredKey?.toLowerCase()?.trim();
      const lowercaseDomain = Array.isArray(domain)?domain.map((d)=>d?.toLowerCase()):[domain?.toLowerCase()];
      const lowercaseTools = Array.isArray(tools)?tools.map((d)=>d?.toLowerCase()):[tools?.toLowerCase()];
      // Check for partial matches in program_name, domain, or specializations
      return (
        lowercaseProgramName?.includes(query) || lowercaseHeading?.includes(query) ||
        lowercaseDomain?.some((d)=>d?.includes(query)) || lowercaseDomain?.some(((d)=>d?.includes(queryWithUnderscore))) ||
        lowercaseTools?.some((d)=>d?.includes(query)) || lowercaseTools?.some(((d)=>d?.includes(queryWithUnderscore))) ||
        lowercaseSponsoredBy?.includes(query)
      );
    });
  }


  const debouncedSearch = debounce((query) => {
    setFilteredPrograms(searchPrograms(query, programs));
  }, 600); // Adjust the delay as needed

  useEffect(() => {
    if(query){
      debouncedSearch(query);
    } else {
      setFilteredPrograms(previousPrograms);
    }
    
    if(query){
      // Call pushToDataLayer only after debounced search
      const handleDataLayerPush = () => {
        pushToDataLayer({
          event: 'search_bar_fill',
          cta_text: query || "NA",
          section_name: 'Explore our online degree programs',
          page_type: getGlobalStateValue('pageType') || "Home Page"
        });
      };
      const timeoutId = setTimeout(handleDataLayerPush, 600); // Match the debounce delay
      return () => clearTimeout(timeoutId); // Cleanup timeout on unmount or query change
    }
  }, [query]);

  return (
    <div className={styles.searchContainer}>
      <input
        type="text"
        placeholder="Search by program name, domain, specialization"
        className={styles.searchInput}
        value={query}
        onChange={(e) => {
          const cleaned = e.target.value
            .replace(/[\u00A0\u2000-\u200D\u202F\u205F\u3000]/g, ' ') // replace uncommon space characters
            .replace(/\./g, '') // remove dots
            .replace(/\s+/g, ' ') // collapse multiple spaces
            .trimStart(); 
          setQuery(cleaned);
        }}
      />
      <Image src="/_a/icons/searchOutlined.svg" alt="Search" className={styles.searchLogo} height={10} width={10} />
    </div>
  );
}
